const options = {
  5: "bg-blue-600/5",
  10: "bg-blue-600/10",
  25: "bg-blue-600/25",
  50: "bg-blue-600/50",
  75: "bg-blue-600/75",
  90: "bg-blue-600/90",
  100: "bg-blue-600",
};

const from = {
  5: "from-blue-600/5",
  10: "from-blue-600/10",
  25: "from-blue-600/25",
  50: "from-blue-600/50",
  75: "from-blue-600/75",
  90: "from-blue-600/90",
  100: "from-blue-600",
};

export default function getBackgroundBlue600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
